import { SortEmployees } from './SortEmployees.main';

export { SortEmployees };
